export default __webpack_public_path__ + "static/media/dark-img.afc2062f.png";